import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Document Library overview</h2>
      <p>
        Welcome to your Document Library, where you’ll find the templates you need to run your
        business. It has two sections, the Business Kitz Library and My Templates, and you can
        switch between them using the buttons at the top.
      </p>
      <h2>Using the Business Kitz Library</h2>
      <p>Browse ready-made templates from Business Kitz by category:</p>
      <ul>
        <li>
          <strong>Business:&nbsp;</strong>operations, compliance and administration
        </li>
        <li>
          <strong>Employment:&nbsp;</strong>contracts, onboarding forms and HR policies
        </li>
        <li>
          <strong>Customers:&nbsp;</strong>agreements, service terms and communication templates
        </li>
        <li>
          <strong>Suppliers:&nbsp;</strong>purchase agreements, onboarding documents and terms and
          conditions
        </li>
      </ul>
      <h2>Using My Templates</h2>
      <ul>
        <li>My Templates is where you keep your reusable templates.</li>
        <li>
          To create a template, find the document you need in the Business Kitz Library and click
          Create Template under Actions. This copies the template to My Templates so you can edit
          and reuse it.
        </li>
        <li>
          <strong>Tip:&nbsp;</strong>Include “Template” in the name, such as “Employment Agreement -
          Casual Template”, so it’s easy to find and reuse.
        </li>
        <li>
          Once you create a document from a template, it's saved in your Document Vault or assigned
          to the relevant Profile. You can then send the document for eSigning.
        </li>
      </ul>
      <h2>Downloading and editing documents</h2>
      <p>
        You can download a document in Word format to edit it yourself. If you notice formatting
        issues, make your changes in Word, then upload the document as a PDF to the relevant Profile
        when it’s ready for eSigning.
      </p>
      <h2>Video tutorials:</h2>
      <ul>
        <li>
          <a
            id='libraryPreviewHowToBrowseTheBusinessLink'
            href='https://youtu.be/EAWlqJnSGCQ?si=qhLgDNSSvwLVMmR7'
            target='_blank'
            rel='noopener noreferrer'
          >
            How to browse the Business Kitz Library
          </a>
        </li>
        <li>
          <a
            id='libraryPreviewHowToCopyATemplateLink'
            href='https://youtu.be/AHSJU3EODt0?si=J_ZszNRSnlRfkgB1'
            target='_blank'
            rel='noopener noreferrer'
          >
            How to copy a template to My Templates
          </a>
        </li>
        <li>
          <a
            id='libraryPreviewHowToCreateADocumentLink'
            href='https://youtu.be/xIHmQkEgaaY?si=kvAOQiPgSRu6mRiE'
            target='_blank'
            rel='noopener noreferrer'
          >
            How to create a document
          </a>
        </li>
        <li>
          <a
            id='libraryPreviewHowToDownloadATemplateLink'
            href='https://youtu.be/WNxcAl6KLv0?si=HxmJii7dpbU1tqxe'
            target='_blank'
            rel='noopener noreferrer'
          >
            How to download a template
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Preview;
